import type { ShareMode, SharingAvailability } from './tauri'

export type SharePreference = 'auto' | ShareMode

/** Old 'tunnel' preferences meant automatic selection for signed-in users. */
export function savedSharePreference(saved: {
  connection?: unknown
  share?: unknown
}): SharePreference {
  if (
    saved.connection === 'auto' ||
    saved.connection === 'tunnel' ||
    saved.connection === 'lan' ||
    saved.connection === 'server'
  ) {
    return saved.connection
  }
  return saved.share === 'lan' ? 'lan' : 'auto'
}

/** Automatic may fall back to public P2P, but never silently publish a LAN-only link. */
export function availableShareMode(
  preference: SharePreference,
  signedIn: boolean,
  availability: SharingAvailability | null,
): ShareMode | null {
  if (!availability) return null
  if (preference !== 'auto') {
    return availability[preference].available && (preference !== 'server' || signedIn)
      ? preference
      : null
  }
  if (signedIn && availability.server.available) return 'server'
  return availability.tunnel.available ? 'tunnel' : null
}

export function resolveShareMode(preference: SharePreference, signedIn: boolean): ShareMode {
  return preference === 'auto' ? (signedIn ? 'server' : 'tunnel') : preference
}
